var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRigth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.86,
    height: 9.769,
    viewBox: "0 0 15.86 9.769",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-2.28 -292.234)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path9413",
    d: "M3.109,297.928H15.367L12.7,300.6a.814.814,0,0,0,1.151,1.151l2.433-2.437,1.624-1.627a.812.812,0,0,0,0-1.145l-4.057-4.062a.814.814,0,1,0-1.151,1.151l2.678,2.672H3.109a.813.813,0,1,0,0,1.625Z",
    transform: "translate(0 0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRigth);
export default __webpack_public_path__ + "static/media/arrow-rigth.b76163b81e4a60acc9e60b71d59046de.svg";
export { ForwardRef as ReactComponent };